module.exports = __webpack_public_path__ + "static/media/addIcon1.c9224e13.svg";